export default {
	targets: {},

	add(id, sprite) {
		this.targets[id] = sprite;
	},

	get(id) {
		return this.targets[id];
	}
};
